(() => {
  let pending = false;
  const buttons = new Map();
  const root = () => window.Shopify?.routes?.root || '/';
  const restore = () => {
    pending = false;
    buttons.forEach((label, button) => {
      button.disabled = false;
      button.innerHTML = label;
    });
    buttons.clear();
  };
  window.addEventListener('pageshow', restore);

  // Each purchase replaces the previous selection; Bundler applies the pack discount.
  window.PanchonaDirectCheckout = async (selection, button, label, destination = 'checkout') => {
    if (pending) return;
    const isForm = selection instanceof FormData;
    const items = isForm
      ? [{ id: selection.get('id'), quantity: Number(selection.get('quantity') || 1) }]
      : selection;
    if (!Array.isArray(items) || !items.length || items.some(item =>
      !/^\d+$/.test(String(item.id)) || !Number.isInteger(item.quantity) || item.quantity < 1
    )) throw new Error('Selección inválida');
    pending = true;
    if (button) buttons.set(button, label);
    try {
      const cleared = await fetch(root() + 'cart/clear.js', {
        method: 'POST', headers: { Accept: 'application/json' }
      });
      if (!cleared.ok) throw new Error('No se pudo reiniciar la selección');
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: isForm ? { Accept: 'application/json' } : {
          'Content-Type': 'application/json', Accept: 'application/json'
        },
        body: isForm ? selection : JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('No se pudo preparar la compra');
      const added = await response.json();
      const lines = added.items || [added];
      const expected = items.reduce((total, item) => total + item.quantity, 0);
      if (lines.reduce((total, item) => total + item.quantity, 0) !== expected) {
        throw new Error('La cantidad disponible no coincide con la selección');
      }
      window.location.assign(root() + destination);
    } catch (error) {
      restore();
      throw error;
    }
  };
})();

// Panchona live bundle offer: only active on the main product page.
(() => {
  const config = window.PanchonaOfferLive;
  if (!config || String(window.Shopify?.theme?.id) !== config.themeId || location.pathname !== '/products/' + config.handle) return;
  const allowed = new Set(config.variantIds);
  for (const packs of [...Object.values(window.PanchonaABPriceConfig?.variants || {}), ...Object.values(window.PanchonaABPriceConfig?.discountVariants || {})]) {
    for (const pack of Object.values(packs)) allowed.add(String(pack.variantId));
  }
  const nativeFetch = window.fetch.bind(window);
  const root = () => window.Shopify?.routes?.root || '/';
  const storageKey = 'panchona-bundle-offer-v1';

  const quizReward = () => {
    try {
      const reward = JSON.parse(localStorage.getItem('panchona-quiz-reward-v1') || 'null');
      return reward && /^[0-9a-f-]{36}$/i.test(reward.quizId)
        && /^PCHQ-[A-F0-9]{20}$/.test(reward.code)
        && [3000,4000,5000].includes(reward.prizeAmount)
        && Date.parse(reward.endsAt) > Date.now() ? reward : null;
    } catch { return null; }
  };
  const activateQuiz = async (reward, sourceVariantId, quantity, group) => {
    const response = await nativeFetch('https://panchona-creadores.vercel.app/api/quiz/respuestas', {
      method:'POST',headers:{'Content-Type':'application/json'},cache:'no-store',signal:AbortSignal.timeout(15000),
      body:JSON.stringify({phase:'activate',quizId:reward.quizId,code:reward.code,sourceVariantId,quantity,group})
    });
    if(!response.ok) throw new Error('No pudimos activar tu regalo. Probá de nuevo; conservás el código en el quiz.');
    const result=await response.json();
    if(result.code!==reward.code||result.prizeAmount!==reward.prizeAmount||!Number.isSafeInteger(result.expectedTotal))
      throw new Error('No pudimos confirmar el descuento del quiz.');
    return result;
  };
  const pesos = amount => new Intl.NumberFormat('es-AR', {style:'currency',currency:'ARS',maximumFractionDigits:0}).format(amount);
  let pending = false;
  const buttons = new Map();
  const restore = () => {
    pending = false;
    buttons.forEach((label, button) => { button.disabled = false; button.innerHTML = label; });
    buttons.clear();
  };
  const forgetOffer = () => {
    try { localStorage.removeItem(storageKey); } catch {}
    window.dispatchEvent(new Event('panchona-offer-live-changed'));
  };
  window.addEventListener('pageshow', restore);
  async function cartRequest(path, body) {
    const response = await nativeFetch(root() + path, body === undefined
      ? {cache:'no-store',signal:AbortSignal.timeout(8000)}
      : {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body),cache:'no-store',signal:AbortSignal.timeout(8000)});
    if (!response.ok) throw new Error('Shopify no pudo preparar el carrito.');
    return response.json();
  }
  function assertIsolated(cart) {
    if (!Array.isArray(cart.items) || cart.items.some(item => !allowed.has(String(item.variant_id)))) {
      throw new Error('Hay otros productos en el carrito.');
    }
  }
  function selectedTotal(cart, variantId, quantity) {
    if (!Array.isArray(cart.items) || cart.items.length < 1
      || cart.items.some(item => String(item.variant_id) !== variantId || !Number.isSafeInteger(item.quantity) || item.quantity < 1)
      || cart.items.reduce((sum, item) => sum + item.quantity, 0) !== quantity || cart.currency !== 'ARS'
      || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) {
      throw new Error('Shopify devolvió un carrito distinto al pack elegido.');
    }
    return cart.total_price / 100;
  }
  function confirmWithoutOffer(amount, extra = '', eligible = true, promisedExtra = 10000) {
    return window.confirm(`${eligible ? `No pudimos aplicar los ${pesos(promisedExtra)} extra.` : 'No pudimos confirmar el carrito.'}${extra}\n\n${amount == null
      ? 'Shopify mostrará el precio final antes de pagar.'
      : `El pack cuesta ${pesos(amount)} sin ese beneficio.`}\n\n¿Querés continuar y revisar el total en Shopify antes de pagar?`);
  }
  window.PanchonaDirectCheckout = async (selection, button, label, destination = 'checkout') => {
    if (pending) return;
    if (!Array.isArray(selection) || selection.length !== 1 || !allowed.has(String(selection[0].id))
      || ![1,2,3,4].includes(selection[0].quantity)) throw new Error('Esta selección no pertenece a la tienda.');
    const item = selection[0];
    const variantId = String(item.id);
    const quantity = item.quantity;
    const ab = await window.PanchonaABPriceReady;
    if (pending) return;
    const attribution = {
      __panchona_ab_price_v2_group: '',
      __panchona_ab_price_v2_visitor: '',
      __panchona_ab_price_v3_group: '',
      __panchona_ab_price_v3_visitor: '',
      __panchona_ab_price_v4_group: '',
      __panchona_ab_price_v4_visitor: '',
      __panchona_ab_price_v5_group: ab?.final || ab?.preview ? '' : ab?.group || '',
      __panchona_ab_price_v5_visitor: ab?.final || ab?.preview ? '' : ab?.visitorId || '',
    };
    const reward = quantity > 1 ? quizReward() : null;
    if (reward && !['A','B'].includes(ab?.group)) throw new Error('No pudimos confirmar tu precio para aplicar el regalo.');
    const baseline = config.prices?.[variantId]?.[quantity];
    if (!Number.isSafeInteger(baseline) || baseline <= 0) throw new Error('No pudimos confirmar el precio de este pack.');
    pending = true;
    if (button) { buttons.set(button,label); button.disabled = true; }
    let navigating = false;
    try {
      if (ab?.group === 'A' || ab?.group === 'B') {
        const target = window.PanchonaABPriceConfig?.variants?.[variantId]?.[quantity];
        if (!target || !/^\d+$/.test(String(target.variantId)) || !Number.isSafeInteger(target.price)) {
          throw new Error('Este pack aún no está disponible.');
        }
        const quiz = reward ? await activateQuiz(reward, variantId, quantity, ab.group) : null;
        if (quiz && (quiz.cartVariantId !== String(target.variantId) || quiz.expectedTotal !== target.price - reward.prizeAmount))
          throw new Error('Shopify devolvió un descuento distinto al regalo mostrado.');
        assertIsolated(await cartRequest('cart.js'));
        await cartRequest('cart/clear.js', {});
        await cartRequest('cart/update.js', { discount: '' });
        await cartRequest('cart/add.js', { items: [{ id: Number(target.variantId), quantity: 1,
          properties: item.properties || {} }] });
        const cart = await cartRequest('cart/update.js', { discount: '', attributes: attribution });
        if (selectedTotal(cart, String(target.variantId), 1) !== target.price) {
          throw new Error('Shopify devolvió un precio distinto al mostrado.');
        }
        navigating = true;
        window.location.assign(root() + destination);
        return;
      }
      let offer;
      try { offer = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch {}
      let code = '';
      let appliedExtra = 0;
      let offerUnavailable = false;
      const promisedExtra = quantity === 2 && offer?.pack2ExtraAmount === 10000 ? 10000 : quantity === 2 ? 5000 : 10000;
      const offered = !reward && quantity > 1 && /^PCH10-[A-F0-9]{20}$/.test(offer?.code || '');
      try {
        assertIsolated(await cartRequest('cart.js'));
        if (offered) {
          try {
            if (Date.parse(offer.endsAt) <= Date.now() + Number(offer.serverOffset || 0)) throw new Error('offer_inactive');
            const response = await nativeFetch(config.endpoint, {method:'POST',headers:{'Content-Type':'application/json'},cache:'no-store',
              signal:AbortSignal.timeout(5000),
              body:JSON.stringify({browserId:offer.browserId,variantId,quantity,benefitVersion:2})});
            if (!response.ok) throw new Error('offer_unavailable');
            const current = await response.json();
            if (!current.active || current.code !== offer.code || current.endsAt !== offer.endsAt
              || Date.parse(current.endsAt) <= Date.parse(current.serverNow)
              || !Number.isSafeInteger(current.extraAmount)
              || (quantity === 2 ? ![5000,10000].includes(current.extraAmount) : current.extraAmount !== 10000)) {
              throw new Error('offer_unavailable');
            }
            code = current.code;
            appliedExtra = current.extraAmount;
          } catch {
            offerUnavailable = true;
            forgetOffer();
          }
        }
        if (reward) {
          const quiz = await activateQuiz(reward, variantId, quantity, 'A');
          if (quiz.cartVariantId !== variantId || quiz.expectedTotal !== baseline - reward.prizeAmount)
            throw new Error('El regalo no coincide con el precio del pack.');
        }
        assertIsolated(await cartRequest('cart.js'));
        await cartRequest('cart/clear.js', {});
        // A previous Shopify discount can survive cart changes.
        await cartRequest('cart/update.js', {discount:''});
        await cartRequest('cart/add.js', {items:selection});
        let cart = await cartRequest('cart/update.js', {discount:reward ? '' : code, attributes:attribution});
        let total = selectedTotal(cart, variantId, quantity);
        if (code && total !== baseline - appliedExtra) {
          code = '';
          offerUnavailable = true;
          forgetOffer();
          cart = await cartRequest('cart/update.js', {discount:''});
          total = selectedTotal(cart, variantId, quantity);
        }
        if (reward && total !== baseline)
          throw new Error('El precio del pack no coincide con el mostrado; no podemos preparar tu código.');
        if (offerUnavailable || total !== baseline - (code ? appliedExtra : 0)) {
          if (!confirmWithoutOffer(total, total !== baseline ? '\nShopify devolvió un precio distinto al mostrado en la página.' : '', offered, promisedExtra)) return;
        }
        navigating = true;
        window.location.assign(root() + destination);
      } catch (error) {
        if (ab?.group) throw error;
        // Shopify's cart permalink can take a validated variant to the cart.
        // The buyer must review its actual products and total there.
        if (!confirmWithoutOffer(baseline, '\nEl carrito no respondió. Es el precio previsto del pack; revisá los productos y el total final en Shopify.', offered, promisedExtra)) return;
        navigating = true;
        window.location.assign(root() + `cart/${variantId}:${quantity}`);
      }
    } finally {
      if (!navigating) restore();
    }
  };
})();
